import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  portrait: {},
  engagementsBoard: {
    '&$portrait': {
      '@media (max-width: 767px)': {
        '& $detailsButton': {
          display: 'none'
        }
      }
    }
  },
  retailValue: {
    marginBottom: theme.spacing(1),
    fontSize: '1rem'
  },
  engagementsListWrapper: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  arrowIcon: {
    fontSize: 25,
    marginRight: 6
  },
  itemContent: {
    padding: theme.spacing(1.125, 1),
    height: '100%',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    position: 'relative',
    zIndex: '2'
  },
  detailsButton: {
    borderRadius: 3,
    color: theme.palette.secondary.main,
    height: 29,
    textTransform: 'capitalize',
    fontSize: 10,
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    flexShrink: 0
  },
  liveNowText: {
    fontSize: 10,
    color: 'white',
    lineHeight: '1rem'
  },
  itemTitleTypography: {
    fontSize: 15,
    color: 'white',
    lineHeight: '1rem'
  },
  backButton: {
    fontSize: 12,
    marginLeft: -13,
    marginBottom: theme.spacing()
  },
  imageOverlay: {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(#1AA3FF27 0%, #333333)'
  },
  imageBox: {
    height: 200,
    flexShrink: 0,
    position: 'relative',
    overflow: 'hidden'
  },
  headerImage: {
    position: 'absolute',
    top: '0',
    left: '0',
    maxHeight: 200,
    objectFit: 'cover'
  },
  donateBox: {
    height: 210,
    display: 'flex',
    flexDirection: 'column',
    background:
      'linear-gradient(130deg, rgba(235,46,107,1) 0%, rgba(26,163,255,1) 100%)',
    fallbacks: {
      background: 'rgb(235,46,107)'
    }
  },
  donateNowText: {
    fontSize: 40,
    color: 'white',
    lineHeight: '55px',
    textAlign: 'center'
  },
  donationAmountBanner: {
    borderTop: '1px solid rgba(255,255,255,0.5)',
    borderBottom: '1px solid rgba(255,255,255,0.5)'
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/styles.js